<div class="dialog-header">
	<div class="header-title">
		<span style="font-size: 120%;">Print Labels</span>
	</div>

	<button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
		<mat-icon>clear</mat-icon>
	</button>
</div>

<div class="edit-block">

	<ng-container *ngIf="!showCabs">
		<lib-progress-spinner></lib-progress-spinner>
	</ng-container>

	<form #userEditForm="ngForm" *ngIf="showCabs">
		<div class="form-block">
			<div class="form-row">
				<p-listbox [options]="projectCabs" [(ngModel)]="selectedCabs" [multiple]="true" [checkbox]="true"
					[disabled]="loadingSpinner" [filter]="true" optionLabel="showName"
					[ngModelOptions]="{standalone: true}" class="p-list-box-block">
					<p-header>
						{{projectName}}
					</p-header>

				</p-listbox>
			</div>
		</div>

		<div class="save-btn-block">
			<button mat-button class="save-btn" (click)="printLabels()"
				[disabled]="selectedCabs.length === 0 || loadingSpinner" tabindex="1" type="submit"
				[ngClass]="{'disabled-button': selectedCabs.length === 0 || loadingSpinner}">
				<span *ngIf="!loadingSpinner">Print</span>
				<lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
			</button>
		</div>
	</form>

</div>